import { Box } from '@mui/material'
import { FC } from 'react'
import { DensityStyleTypes } from 'types'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import { NcoStatusContainer } from 'styles/elements/styleElements'
import { renderColorByString } from 'components/DataGrid/renderColorByString'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'

interface SeoTierProps {
  params: GridRenderCellParams
  densityStyles: DensityStyleTypes
}

const SeoTierCell: FC<SeoTierProps> = ({ params, densityStyles }) => {
  //@ts-ignore
  //@ts-ignore
  if (params?.rowNode?.isAutoGenerated) return
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        padding: densityStyles.padding,
        gap: densityStyles.gap,
      }}
    >
      <>
        <>
          {params?.value ? (
            <NcoStatusContainer
              sx={{
                bgcolor: renderColorByString(params?.value),
                textAlign: 'center',
              }}
            >
              {params?.value}
            </NcoStatusContainer>
          ) : (
            <CheckCircleIcon
              sx={{
                height: '100%',
                color: 'rgb(96, 94, 94)',
                opacity: '0.2',
              }}
            />
          )}
        </>
      </>
    </Box>
  )
}
export default SeoTierCell
